/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { IVCSStrictHttpResponse } from '../../ivcs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrescriptionModel } from '../../models/prescription-model';

export interface ConsumerGetPrescriptionIdGet$Plain$Params {
  id: string;
}

export function consumerGetPrescriptionIdGet$Plain(http: HttpClient, rootUrl: string, params: ConsumerGetPrescriptionIdGet$Plain$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<PrescriptionModel>> {
  const rb = new RequestBuilder(rootUrl, consumerGetPrescriptionIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as IVCSStrictHttpResponse<PrescriptionModel>;
    })
  );
}

consumerGetPrescriptionIdGet$Plain.PATH = '/Consumer/GetPrescription/{id}';
